var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.teams),function(team){return _c('settings-dialog-teams-and-access-teams-list-item',{key:team.id,attrs:{"team":team},on:{"item-clicked":function($event){return _vm.$emit('item-clicked', $event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }